export default "__VITE_ASSET__xsZ9klj8__"